import {Box, useToast, Select} from '@chakra-ui/react';
import { useEffect,useState } from 'react';
import { getLokacijeAllWithDefaultOdjeljak } from '../../util/apiLokacija';

export default function LokacijaFarmaDefaultSelect({readonly=false,selected=-1,onSelect, size='xs'}) {
    const [state,setState]=useState({selecteditem:selected,data:[],errloading:false})
    const toast=useToast();

    const fetchData=async()=>{
        try {
      
            let res=await getLokacijeAllWithDefaultOdjeljak();
            if (res.status===200) {
               setState({...state,data:res.res});
                
            } else {
                throw new Error(res.message);
            }
            
            onSelect(res.res[0].odjeljak_id);
        } catch (error) {
            toast({
                title:"Greška kod dohvata podataka.",
                status:"error",
                description:error.message,
                isClosable:true,
                duration:2000,
                position:"top-right",
            });
        }
}

useEffect(() => {
  
  fetchData();
}, [])

const lokacijaSelect=(event)=>{
    setState({...state,selecteditem:event.target.value});
    onSelect(event.target.value);
}

const showData=()=>{
    if (state.data.length>0) {
        return (
            <Select focusBorderColor='grunt2.400' size={size} variant={'filled'} value={state.selecteditem} onChange={lokacijaSelect} isDisabled={readonly}>
                {
                    state.data.map((item,i)=>{
                        return (
                            <option key={i} value={item.odjeljak_id}>{item.lokacija_naziv}</option>
                        )
                    })
                }
            </Select>
        )
    }
}

  return (
    <Box>
        
            {showData()}
        
    </Box>
  )
}
